import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography, Skeleton } from '@mui/material';
import { collection, getCountFromServer, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebase.config';
import { UserAuth } from '../../../../context/AuthContext';
import Iconify from '../../../../components/Iconify';
import LucideIcon from '../../../../components/LucideIcon';

const PopulationStats = () => {
  const { user } = UserAuth();
  const [loading, setLoading] = useState(true);
  const [populationsCount, setPopulationsCount] = useState(0);

  const fetchStats = async () => {
    try {
      if (!user) return;
      setLoading(true);

      const orgSnap = await getDoc(doc(db, 'organisateurs', user.uid));
      const orgId = orgSnap.data()?.idOrg;

      const path = `organisations/${orgId}/crm/${orgId}/populations`;
      const popQuery = collection(db, path);
      const popSnap = await getCountFromServer(popQuery);

      setPopulationsCount(popSnap.data().count || 0);

    } catch (e) {
      console.error('Erreur populations:', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, [user]);

  return (
    <Box sx={{ p: 2, bgcolor: '#D2C2FF', borderRadius: '10px', boxShadow: 5, height: '100%' }}>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LucideIcon name='Users'/>
          <Typography variant="body2">Populations</Typography>
        </Stack>

        {!loading ? (
          <Stack direction="column"  alignItems="baseline">
            <Typography variant="h5">{populationsCount}</Typography>
            <Typography variant="body2">segments</Typography>
          </Stack>
        ) : (
          <Stack direction="row" spacing={1}>
            <Skeleton width={50} height={30} />
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default PopulationStats;
